import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function AdminOrders() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-orders"], queryFn: async () => (await api.get("/admin/orders")).data });
  if (isLoading) return <Loader2 className="h-8 w-8 animate-spin text-[#DCA846]" />;

  return (
    <div>
      <h1 className="font-display text-3xl font-bold uppercase tracking-tight">Orders & Payments</h1>
      <div className="mt-6 overflow-x-auto rounded-lg border border-white/10">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900 text-left text-xs uppercase text-zinc-400">
            <tr><th className="p-3">Order</th><th className="p-3">Course</th><th className="p-3">Amount</th><th className="p-3">Coupon</th><th className="p-3">Payment</th><th className="p-3">Date</th></tr>
          </thead>
          <tbody>
            {data.length === 0 ? <tr><td colSpan={6} className="p-6 text-center text-zinc-500">No orders yet.</td></tr> :
              data.map((o) => (
                <tr key={o.id} className="border-t border-white/5" data-testid={`admin-order-${o.id}`}>
                  <td className="p-3 font-mono text-xs text-zinc-500">{o.id.slice(0, 8)}</td>
                  <td className="p-3">{o.course_title}</td>
                  <td className="p-3">${Number(o.amount).toFixed(2)}</td>
                  <td className="p-3 text-zinc-400">{o.coupon || "-"}</td>
                  <td className="p-3"><Status s={o.payment_status} /></td>
                  <td className="p-3 text-zinc-500">{new Date(o.created_at).toLocaleString()}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Status({ s }) {
  const map = { paid: "text-emerald-400", pending: "text-yellow-400", failed: "text-red-400", refunded: "text-zinc-400", expired: "text-zinc-500" };
  return <span className={`uppercase text-xs ${map[s] || "text-zinc-400"}`}>{s}</span>;
}
